// extracted by mini-css-extract-plugin
module.exports = {"container":"QAContainer_container__cf54J"};